import { Button } from "@mui/material";
import React from "react";
import { fonts, themes } from "../themes/themes";

interface CustomButtonClockInClockOutProps {
  btnLabel: string;
  disabled?: boolean;
  onClick?: any;
}

const CustomButtonClockInClockOut: React.FC<
  CustomButtonClockInClockOutProps
> = ({ onClick, btnLabel, disabled = false }) => {
  return (
    <Button
      style={{
        width: "auto",
        height: "42px",
        backgroundColor:
          btnLabel === "Clock In"
            ? themes.primaryMain
            : btnLabel == "Clocked In"
            ? themes.greyDefault_500
            : themes.defaultError,
        color: "white",
        fontFamily: fonts.fontFamily,
        fontSize: fonts.title,
        boxShadow: "0px 3px 3px #00000061",
        borderRadius: "4px",
        paddingLeft: "1em",
        paddingRight: "1em",
        cursor: "pointer",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {btnLabel}
    </Button>
  );
};
export default CustomButtonClockInClockOut;
